export class ExportHelper {
  static getFileName(prefix: string = "", format = "csv"): string {
    //SLG Comment: Set file name based on language
    const browserLang = navigator.language || "en";
    const lang = browserLang.split("-")[0];
    const productName =
      lang === "fr"
        ? "Gestionnaire_de_mots_de_passe_Assist_Identité"
        : "ID_Assist_Password_Manager";
    if (format === "encrypted_json") {
      if (prefix == "") {
        prefix = "encrypted";
      } else {
        prefix = "encrypted_" + prefix;
      }
      format = "json";
    }

    const now = new Date();
    const dateString =
      now.getFullYear() +
      "" +
      this.padNumber(now.getMonth() + 1, 2) +
      "" +
      this.padNumber(now.getDate(), 2) +
      this.padNumber(now.getHours(), 2) +
      "" +
      this.padNumber(now.getMinutes(), 2) +
      this.padNumber(now.getSeconds(), 2);

    return productName + (prefix ? "_" + prefix : "") + "_export_" + dateString + "." + format;
  }

  private static padNumber(num: number, width: number, padCharacter = "0"): string {
    const numString = num.toString();
    return numString.length >= width
      ? numString
      : new Array(width - numString.length + 1).join(padCharacter) + numString;
  }
}
